import { tVector2, tVector4 } from 'Utility/ArrayHelper';
import { ILimit } from 'Utility/MathHelper';
import { Random } from '../../Utility/Random';

export enum GrowthStage {
    LOCKED = 'locked',
    GROWING = 'growing',
    READY = 'ready',
    HARVESTED = 'harvested',
}

interface ISharePositioningData {
    payloadAvatarPosition: tVector2;
}

interface IAnchoredSharePositioningData extends ISharePositioningData {
    anchors: tVector4;
}

interface IOffsetSharePositioningData extends ISharePositioningData {
    offsets: tVector4;
}

export interface IFieldSharePositioningData {
    crop: IOffsetSharePositioningData;
    field: IAnchoredSharePositioningData;
    threeStar: IOffsetSharePositioningData;
    hardShare: tVector2;
}

export interface IFieldData {
    id: string;
    requiredLevel: number[];
    levelRange: ILimit;
    growthStages: {
        [key in GrowthStage]: Random.IWeightedItem<string>[];
    };
    cropUnlockedTextures: string[];
    nodeTexture: string;
    cropSettings: ICropSettings;
    shares: IFieldSharePositioningData;
}

export interface IHarvestSettings {
    originPoint: { x: number; y: number };
    radius: number;
    count: number;
    icons: Random.IWeightedItem<string>[];
}

export interface ICropSettings {
    harvestSettings: IHarvestSettings;
    base: string;
}

export type tCropTextureMap = {
    [key in GrowthStage]: Random.IWeightedItem<string>[];
};
